module.exports = __webpack_public_path__ + "assets/PTS75F-webfont.2fc89e4bb41ae3747474e804b2c1ee95b9ff4cb01056d18e16a1dfb7d3e9ba68.woff";